import { render, staticRenderFns } from "./ShippingMethodSelfCollection.vue?vue&type=template&id=bdd3a946&"
import script from "./ShippingMethodSelfCollection.vue?vue&type=script&lang=js&"
export * from "./ShippingMethodSelfCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports